export const PlanTypes = {
  Base: "Base",
  Peak: "Peak",
  PeakPlus: "Peak Plus",
  PeakSilver: "Peak Silver",
  PeakResults: "Peak Results",
  OneCrunch: "One Crunch",
  CityCrunch: "City Crunch",
  AllCrunch: "All Crunch",
  AllCrunchSilver: "All Crunch Silver"
}

export const PaymentTypes = {
  Monthly: 'Monthly',
  MonthlyWithCommitment: 'Monthly with Annual Commitment',
  Annually: 'Annually'
}


export class Plan {
  constructor(data) {
   Object.assign(this, data);
  }

  static fromArray(data) {
    return data.map(item => new Plan(item))
  }
}
